(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation"]) return;
  try {
    
	const nav = document.getElementById("nav");
    const navUl = document.getElementById("nav-main");
    const navButton = document.getElementById("nav-mobile-burger");

    const onMobileNavClickHandler = (e) => {
      navButton.classList.toggle("is-active");
      nav.classList.toggle("nav--open");
    };

    const windowScroll = (e) => {
      const scroll = window.pageYOffset;
      scroll >= 50 ? nav.classList.remove("nav--no-logo") : nav.classList.add("nav--no-logo");
    };

    navButton.addEventListener("click", onMobileNavClickHandler);
    window.addEventListener("scroll", windowScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"]) return;
  try {
    
	const cssClassElement = document.getElementById('product-info-css');
	const cssClass = cssClassElement.innerText;
	const nav = document.getElementById('nav');
	nav.classList.add(`nav--${cssClass}`);

  } catch(e) { console.error(e); }
})();
})();
